const catalogMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function showCatalog(target) {
  target.focus({ preventScroll: true });
  target.scrollIntoView({ behavior: catalogMotion.matches ? 'instant' : 'smooth', block: 'start' });
}

document.addEventListener('click', (event) => {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('a[href]');
  if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
  const url = new URL(link.href, window.location.href);
  const target = document.getElementById('catalog');
  if (!target || url.origin !== location.origin || url.pathname !== location.pathname || url.hash !== '#catalog') return;
  event.preventDefault();
  const drawer = link.closest('header-drawer');
  if (drawer?.isOpen) {
    drawer.close();
    window.setTimeout(() => showCatalog(target), catalogMotion.matches ? 0 : 420);
  } else {
    showCatalog(target);
  }
  if (location.hash !== '#catalog') history.pushState(null, '', '#catalog');
});

if (location.hash === '#catalog') {
  const target = document.getElementById('catalog');
  if (target) requestAnimationFrame(() => showCatalog(target));
}
